const style = {
  border: "none",
  color: "#0388CC",
  fontSize: "13px",
  fontWeight: "lighter",
};

const columns = [
  {
    name: "image",
    header: <h3 style={{ fontWeight: "700" }}></h3>,
    defaultFlex: 0.7,
    headerProps: { style: style },
  },
  {
    name: "id",
    header: <h3 style={{ fontWeight: "700" }}>ID</h3>,
    defaultFlex: 0.5,
    type: "number",
    headerProps: { style: style },
    className:"text-[14px] font-[400] text-[#0388CC]"
  },
  {
    name: "name",
    header: <h3 style={{ fontWeight: "700", fontFamily:"Poppins" }}>Name</h3>,
    defaultFlex: 1,
    headerProps: { style: style },
    className:"font-[400] font-arabic"
  },
  {
    name: "cooksByCategories",
    header: <h3 style={{ fontWeight: "700" }}>Cooks By Categories</h3>,
    defaultFlex: 3,
    headerProps: { style: style },
    className:"font-[400]"
  },
  {
    name: "cooks",
    header: <h3 style={{ fontWeight: "700" }}>Cooks</h3>,
    defaultFlex: 1,
    headerProps: { style: style },
    className:"text-[14px] w-fit px-[5px] font-[400] rounded text-[#0388CC]"
  },
  {
    name: "lastUpdated",
    header: <h3 style={{ fontWeight: "700" }}>Last Update</h3>,
    defaultFlex: 1,
    headerProps: { style: style },
    className:"font-[400]"
  },
  {
    name: "view",
    header: <h3 style={{ fontWeight: "700" }}></h3>,
    defaultFlex: 0.5,
    headerProps: { style: style },
  },
  {
    name: "delete",
    header: <h3 style={{ fontWeight: "700" }}></h3>,
    defaultFlex: 0.5,
    headerProps: { style: style },
  },
];

export default columns;
